// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__taBt+","topMenu":"styles_topMenu__ocLpj","list":"styles_list__YNEqB"};